import { Injectable } from '@angular/core';
import { RedirectCommand, Resolve } from '@angular/router';

@Injectable()
export class TenantConfigResolver implements Resolve<{ tenantId: string } | null | RedirectCommand> {
  config: { tenantId: string } | null = null;

  resolve() {
    return this.config;
  }
}
